var _path, _g, _path2, _g2, _path3, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWoz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 37,
    viewBox: "0 0 65 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_888_4551",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 43,
    y: 0,
    width: 22,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.8125 0H43.251V18.6185H64.8125V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_888_4551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7043 18.6008H59.4379L64.8136 9.29158L59.4379 0H48.7043L43.3286 9.29158L48.7043 18.6008Z",
    fill: "#86C7ED"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_888_4551",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 0,
    width: 33,
    height: 37
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9557 0H21.7135V36.8015H53.9557V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_888_4551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.24 15.1643L25.6051 15.7939L27.2243 18.6008H27.2302L34.4605 31.1053L37.9756 37.1781H48.7093L54.0849 27.8865L50.4639 21.6313L41.6026 6.29638L37.9697 0H27.2125L21.8545 9.29157L25.2342 15.1643",
    fill: "#A066CB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_888_4551",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 37
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5932 0H0.368652V36.8015H32.5932V0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_888_4551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.01916 15.6115H4.00738L13.2043 31.5643L13.2279 31.5525L16.4839 37.1781H27.2175L32.5932 27.8865L27.2175 18.5949L21.8478 9.31511L21.8654 9.28569L16.478 0H5.74432L0.368652 9.29157L4.01916 15.6174",
    fill: "#1836B2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoz);
export default __webpack_public_path__ + "static/media/WOZ.258d3dea32f9bd39543d281b5dd11ba1.svg";
export { ForwardRef as ReactComponent };